import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Card, List, Input, Checkbox, message, Spin, Progress, Select, Radio, Tag, Tabs, Col, Row, Form } from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined, MinusOutlined, InfoCircleOutlined, CheckCircleTwoTone, CloseCircleTwoTone, LoadingOutlined, SaveOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Editor } from "@tinymce/tinymce-react";
import courseService from "../../services/course.service";
import MatchingQuestion from "./MatchingQuestion";
import TabPane from "antd/es/tabs/TabPane";

const { TextArea } = Input;

const ControleConnaissanceManager = ({ subjectId, courseId, showInPage = false }) => {
  const editorRef = useRef(null);

  // --- Tous tes useState ici ---
  const [quizzes, setQuizzes] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isQuizModalVisible, setIsQuizModalVisible] = useState(false);
  const [newQuizTitle, setNewQuizTitle] = useState("");
  const [newQuestionText, setNewQuestionText] = useState("");
  const [newQuestionType, setNewQuestionType] = useState("QCU");
  const [newAnswerText, setNewAnswerText] = useState("");
  const [newQuestionExplanation, setNewQuestionExplanation] = useState("");
  const [progressValues, setProgressValues] = useState({});
  const [editQuizId, setEditQuizId] = useState(null);
  const [editQuizTitle, setEditQuizTitle] = useState("");
  const [attemptOnce, setAttemptOnce] = useState(false);
  const [quizCountsInCertificate, setQuizCountsInCertificate] = useState({});
  const [editQuestionId, setEditQuestionId] = useState(null);
  const [editQuestionText, setEditQuestionText] = useState("");
  const [editQuestionScore, setEditQuestionScore] = useState("");
  const [editQuestionType, setEditQuestionType] = useState("");
  const [loadingSaveQuestion, setLoadingSaveQuestion] = useState(false);
  const [totalScore, setTotalScore] = useState(0);
  const [leftText, setLeftText] = useState("");
  const [rightText, setRightText] = useState("");
  const [selectedElementType, setSelectedElementType] = useState("SUBJECT");
  const [courseElements, setCourseElements] = useState([]); // éléments plats

  const [editElementType, setEditElementType] = useState("SUBJECT");
  const [editReferenceElementId, setEditReferenceElementId] = useState(null);
  const [editPositioning, setEditPositioning] = useState(null);

const [progressPercentage, setProgressPercentage] = useState(0);

  const handleAddMatchingPair = async () => {
    if (!leftText.trim() || !rightText.trim() || !selectedQuestion) return;

    try {
      const pair = await courseService.addMatchingPairToQuestion(selectedQuestion.id, {
        leftText,
        rightText
      });

      message.success("Paire ajoutée !");
      setLeftText("");
      setRightText("");

      // 🟡 Recharge toutes les questions du quiz sélectionné
      await handleSelectQuiz(selectedQuiz); // ✅ Recharge questions + réponses automatiquement

    } catch (error) {
      console.error("Erreur API :", error.response?.data || error.message);
      message.error("Erreur lors de l'ajout de la paire.");
    }
  };





  const fetchElementsByType = async (type) => {
    if (type !== "SUBJECT") {
      setCourseElements([]); // vider la liste si ce n'est pas un sujet
      return;
    }

    try {
      const elements = await courseService.Getgroupnames(courseId);
      console.log("Groupes récupérés :", elements);
      setCourseElements(Array.isArray(elements) ? elements : []);
    } catch (err) {
      message.error("Erreur chargement des groupes");
    }
  };

  const handleEditQuestion = async () => {
    if (!editQuestionText.trim() || !editQuestionId) return;

    setLoadingSaveQuestion(true);

    try {
      await courseService.updateQuestion(editQuestionId, {
        text: editQuestionText,
        score: editQuestionScore,
        questionType: editQuestionType,
      });

      message.success("Question mise à jour !");
      setQuestions(questions.map(q =>
        q.id === editQuestionId
          ? { ...q, text: editQuestionText, score: editQuestionScore, questionType: editQuestionType }
          : q
      ));

      setEditQuestionId(null);
      setEditQuestionText("");
      setEditQuestionScore("");
      setEditQuestionType("");
    } catch (error) {
      message.error("Erreur lors de la mise à jour de la question.");
    }

    setLoadingSaveQuestion(false);
  };




  const handleQuizCheckboxChange = (quizId, checked) => {
    setQuizCountsInCertificate(prev => ({
      ...prev,
      [quizId]: checked
    }));
  };


  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        setLoading(true);
        let response = [];

        if (courseId) {
          // 🔥 Nouvel appel pour cours
          response = await courseService.getQuizzesByCourse(courseId);
        } else if (subjectId) {
          // 🔥 Sinon appel pour sujet
          response = await courseService.getQuizzesBySubject(subjectId);
        }

        setQuizzes(response);
      } catch (error) {
        console.error("Erreur lors de la récupération des quizzes :", error);
        message.error("Erreur lors de la récupération des quizzes.");
      } finally {
        setLoading(false);
      }
    };

    fetchQuizzes();
  }, [courseId, subjectId]);


  useEffect(() => {
    const total = questions.reduce((sum, q) => sum + (parseFloat(q.score) || 0), 0);
    setTotalScore(total);
  }, [questions]);


  // --- Toutes tes fonctions (fetchQuizzes, handleSaveQuiz, etc) restent identiques ---
  const handleSelectQuiz = async (quiz) => {
    setSelectedQuiz(quiz);
    try {
      const response = await courseService.getQuestionsByQuiz(quiz.id);
      setQuestions(response);
      setSelectedQuestion(null);
      setAnswers([]);
    } catch (error) {
      message.error("Erreur lors de la récupération des questions.");
    }
  };

  // const handleEditQuizClick = (quiz) => {
  //   setEditQuizId(quiz.id);
  //   setEditQuizTitle(quiz.title);
  //   setAttemptOnce(quiz.attemptOnce || false);
  // };
  const handleEditQuizClick = (quiz) => {
    setEditQuizId(quiz.id);
    setEditQuizTitle(quiz.title);
    setAttemptOnce(quiz.attemptOnce || false);
    setEditElementType(quiz.elementType || "SUBJECT");
    setEditReferenceElementId(quiz.referenceElementId || null);
    setEditPositioning(quiz.positioning || null);

    if (quiz.elementType === "SUBJECT") {
      fetchElementsByType("SUBJECT"); // Charger la liste
    }
  };


  const handleDeleteQuiz = async (quizId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer ce quiz ?",
      content: "Cette action est irréversible.",
      okText: "Oui, supprimer",
      okType: "danger",
      cancelText: "Annuler",
      onOk: async () => {
        try {
          await courseService.deleteQuiz(quizId);
          message.success("Quiz supprimé !");
          setQuizzes(quizzes.filter(q => q.id !== quizId));
        } catch (error) {
          message.error("Erreur lors de la suppression du quiz.");
        }
      },
    });
  };


  const handleAddQuestion = async () => {
    if (!newQuestionText.trim() || !selectedQuiz) return;
    try {
      const newQuestion = await courseService.addQuestionToQuiz(selectedQuiz.id, {
        text: newQuestionText,
        explanation: "",
        questionType: newQuestionType,
        quiz: { id: selectedQuiz.id },
        score: 0
      });

      setQuestions([...questions, newQuestion]);
      setNewQuestionText("");
      message.success("Question ajoutée avec succès !");

      // ✅ Si c'est une question de type VRAI_FAUX, ajouter deux réponses automatiquement
      if (newQuestionType === "VRAI_FAUX") {
        const trueAnswer = await courseService.addAnswerToQuestion(newQuestion.id, {
          text: "Vrai",
          isCorrect: false
        });

        const falseAnswer = await courseService.addAnswerToQuestion(newQuestion.id, {
          text: "Faux",
          isCorrect: false
        });

        setAnswers([trueAnswer, falseAnswer]);
      }

    } catch (error) {
      message.error("Erreur lors de l'ajout de la question.");
    }
  };


  const handleDeleteQuestion = async (questionId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette question ?",
      content: "Cette action est irréversible.",
      okText: "Oui, supprimer",
      okType: "danger",
      cancelText: "Annuler",
      onOk: async () => {
        try {
          await courseService.deleteQuestion(questionId);
          message.success("Question supprimée !");
          setQuestions(questions.filter(q => q.id !== questionId));
          if (selectedQuestion?.id === questionId) {
            setSelectedQuestion(null);
            setAnswers([]);
          }
        } catch (error) {
          message.error("Erreur lors de la suppression de la question.");
        }
      },
    });
  };


  const handleAddQuiz = async () => {
    try {
      const values = await form.validateFields();


                 console.log("bbbbbbb"+JSON.stringify(values, null, 2));

      const payload = {
        title: newQuizTitle,

  
        attemptOnce,
        referenceElementId: values.referenceElementId,
        positioning: values.positioning
      };

      console.log("📦 Payload envoyé à l'API :", payload); // Affichage pour analyse

      const newQuiz = await courseService.addQuizToCourse(courseId, payload);

      message.success("Quiz ajouté avec succès !");
      setQuizzes([...quizzes, newQuiz]);
      setNewQuizTitle("");
      setIsQuizModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error("Erreur lors de l'ajout du quiz.");
      console.error("❌ Erreur handleAddQuiz :", error);
    }
  };


//   const handleAddQuiz = async () => {
//     alert(" je suis dans le bloc ")
//   console.log("🚀 Début handleAddQuiz");

//   try {
//     const values = await form.validateFields();

//     const payload = {
//       title: newQuizTitle,
//       attemptOnce,
//       referenceElementId: values.referenceElementId,
//       positioning: values.positioning,
//       progressPercentage: progressPercentage // ✅ Ajouté
//     };

//     console.log("📦 Payload envoyé à l'API :", payload);

//     const newQuiz = await courseService.addQuizToCourse(courseId, payload);

//     message.success("Quiz ajouté avec succès !");
//     setQuizzes([...quizzes, newQuiz]);
//     setNewQuizTitle("");
//     setIsQuizModalVisible(false);
//     form.resetFields();
//     setProgressPercentage(0); // Réinitialiser
//   } catch (error) {
//     console.error("❌ Erreur handleAddQuiz :", error);
//     alert("⚠️ Erreur lors de l'ajout du quiz :\n" + error);
//     message.error("Erreur lors de l'ajout du quiz.");
//   }
// };





  const handleProgressChange = (quizId, value) => {
    const numericValue = parseFloat(value.replace(",", "."));
    if (!isNaN(numericValue)) {
      setQuizzes(prev =>
        prev.map(q => q.id === quizId ? { ...q, progressPercentage: numericValue } : q)
      );
    }
  };


  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(answers);
    const [movedItem] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, movedItem);
    setAnswers(reordered);
  };


  // Valider et forcer entre 0 et 100
  const handleProgressBlur = (quizId) => {
    setQuizzes(prev =>
      prev.map(q => {
        if (q.id === quizId) {
          const validated = Math.max(0, Math.min(100, parseFloat(q.progressPercentage) || 0));
          return { ...q, progressPercentage: validated };
        }
        return q;
      })
    );
  };

  // Bouton +10%
  const increaseProgress = (quizId) => {
    setQuizzes(prev =>
      prev.map(q => q.id === quizId ? { ...q, progressPercentage: Math.min(100, (q.progressPercentage || 0) + 10) } : q)
    );
  };

  const handleValidateDragDropOrder = async () => {
    if (!selectedQuestion) return;
    try {
      const orderedAnswerIds = answers.map(a => a.id);
      await courseService.updateAnswersOrder(selectedQuestion.id, orderedAnswerIds);
      message.success("Ordre des réponses sauvegardé !");
    } catch (error) {
      message.error("Erreur lors de la sauvegarde de l'ordre.");
    }
  };

  // Bouton -10%
  const decreaseProgress = (quizId) => {
    setQuizzes(prev =>
      prev.map(q => q.id === quizId ? { ...q, progressPercentage: Math.max(0, (q.progressPercentage || 0) - 10) } : q)
    );
  };

  const handleSelectQuestion = async (question) => {
    setSelectedQuestion(question);
    setNewQuestionExplanation(question.explanation || "");
    try {
      if (question.questionType === "MATCHING") {
        // 🔁 Récupérer les paires pour une question de type MATCHING
        const response = await courseService.getMatchingPairsByQuestion(question.id);

        setAnswers(response); // Ici chaque élément a leftText et rightText
        console.log("🎯 Matching pairs récupérées :", response);

      } else {
        // 🎯 Récupérer les réponses classiques (QCM, QCU, etc.)
        const response = await courseService.getAnswersByQuestion(question.id);
        setAnswers(response);
      }
    } catch (error) {
      message.error("Erreur lors de la récupération des réponses.");
    }
  };


  const handleUpdateExplanation = async () => {
    if (!selectedQuestion) return;
    try {
      await courseService.updateQuestionExplanation(selectedQuestion.id, newQuestionExplanation);
      message.success("Explication mise à jour !");
    } catch (error) {
      message.error("Erreur lors de la mise à jour de l'explication.");
    }
  };

  // const handleSaveQuiz = async (quizId) => {
  //   if (!editQuizTitle.trim()) return;

  //   try {
    

  //     await courseService.updateQuiz(quizId, {
  //       title: editQuizTitle,
  //       attemptOnce,
  //       elementType: editElementType,
  //       referenceElementId: editReferenceElementId,
  //       positioning: editPositioning
  //     });

  //     message.success("Quiz mis à jour !");
  //     setQuizzes(quizzes.map(q =>
  //       q.id === quizId ? {
  //         ...q,
  //         title: editQuizTitle,
  //         attemptOnce: attemptOnce
  //       } : q
  //     ));
  //     setEditQuizId(null);
  //     setEditQuizTitle("");
  //   } catch (error) {
  //     message.error("Erreur lors de la mise à jour du quiz.");
  //   }
  // };

  const handleSaveQuiz = async (quizId) => {
    // alert(" je suis en train de modifier les dernier changement ")
  if (!editQuizTitle.trim()) return;

  try {
    // ✅ Récupérer la progression du quiz en cours d'édition
    const quizToUpdate = quizzes.find(q => q.id === quizId);
    const progress = quizToUpdate?.progressPercentage || 0;

    // ✅ Mettre à jour avec progression
    await courseService.updateQuiz(quizId, {
      title: editQuizTitle,
      attemptOnce,
      elementType: editElementType,
      referenceElementId: editReferenceElementId,
      positioning: editPositioning,
      progressPercentage: progress
    });

    message.success("Quiz mis à jour !");
    
    // ✅ Mettre à jour le state local
    setQuizzes(quizzes.map(q =>
      q.id === quizId
        ? {
            ...q,
            title: editQuizTitle,
            attemptOnce,
            progressPercentage: progress
          }
        : q
    ));

    setEditQuizId(null);
    setEditQuizTitle("");
  } catch (error) {
    message.error("Erreur lors de la mise à jour du quiz.");
  }
};


  const handleAddAnswer = async () => {
    if (!newAnswerText.trim() || !selectedQuestion) return;

    try {
      const newAnswer = { text: newAnswerText, isCorrect: false }; // Toujours faux au départ
      const savedAnswer = await courseService.addAnswerToQuestion(selectedQuestion.id, newAnswer);

      setAnswers([...answers, savedAnswer]);
      setNewAnswerText("");
      message.success("Réponse ajoutée !");
    } catch (error) {
      message.error("Erreur lors de l'ajout de la réponse.");
    }
  };

  const handleSelectCorrectAnswer = async (selectedId) => {
    if (!selectedQuestion) return;

    let updatedAnswers;

    if (selectedQuestion.questionType === "QCU" || selectedQuestion.questionType === "VRAI_FAUX") {
      updatedAnswers = answers.map(a => ({
        ...a,
        isCorrect: a.id === selectedId
      }));
    } else if (selectedQuestion.questionType === "QCM") {
      updatedAnswers = answers.map(a =>
        a.id === selectedId ? { ...a, isCorrect: !a.isCorrect } : a
      );
    }

    setAnswers(updatedAnswers);

    try {
      const correctAnswerIds = updatedAnswers.filter(a => a.isCorrect).map(a => a.id);
      await courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds);
      message.success("Réponses mises à jour !");
    } catch (error) {
      message.error("Erreur lors de la mise à jour des réponses correctes.");
    }
  };

  const renderAnswerInput = () => {
    if (!selectedQuestion) return null;

    switch (selectedQuestion.questionType) {
      case "QCU":
        return (
          <Radio.Group
            value={answers.find(a => a.isCorrect)?.id}
            onChange={(e) => handleSelectCorrectAnswer(e.target.value)}
          >
            {answers.map(answer => (
              <Radio key={answer.id} value={answer.id}>
                {answer.text}
              </Radio>
            ))}
          </Radio.Group>
        );

      case "QCM":
        return (
          <Checkbox.Group
            value={answers.filter(a => a.isCorrect).map(a => a.id)}
            // onChange={(checkedValues) => {
            //   checkedValues.forEach(id => handleSelectCorrectAnswer(id));
            // }}
            onChange={(checkedValues) => {
              const updatedAnswers = answers.map((a) => ({
                ...a,
                isCorrect: checkedValues.includes(a.id),
              }));
              setAnswers(updatedAnswers);

              const correctAnswerIds = updatedAnswers.filter(a => a.isCorrect).map(a => a.id);

              // Appel unique à l'API
              courseService.updateCorrectAnswers(selectedQuestion.id, correctAnswerIds)
                .then(() => {
                  message.success("Réponses mises à jour !");
                })
                .catch(() => {
                  message.error("Erreur lors de la mise à jour des réponses correctes.");
                });
            }}

          >
            {answers.map(answer => (
              <Checkbox key={answer.id} value={answer.id}>
                {answer.text}
              </Checkbox>
            ))}
          </Checkbox.Group>
        );

      case "VRAI_FAUX":
        return (
          <Radio.Group
            value={answers.find(a => a.isCorrect)?.id}
            onChange={(e) => handleSelectCorrectAnswer(e.target.value)}
          >
            {answers.map(answer => (
              <Radio key={answer.id} value={answer.id}>
                {answer.text}
              </Radio>
            ))}
          </Radio.Group>
        );

      case "DRAG_DROP":
        return (
          <>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="answers-list">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps} style={{ padding: 10, background: "#f8f9fa", borderRadius: 5 }}>
                    {answers.map((answer, index) => (
                      <Draggable key={String(answer.id)} draggableId={String(answer.id)} index={index}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              padding: 10,
                              margin: "5px 0",
                              background: "#ffffff",
                              border: "1px solid #ddd",
                              borderRadius: 5,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              ...provided.draggableProps.style,
                            }}
                          >
                            {answer.text}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            {/* 🔵 Bouton pour valider l'ordre */}
            <Button
              type="primary"
              style={{ marginTop: "10px" }}
              onClick={handleValidateDragDropOrder}
            >
              Valider l'ordre des réponses
            </Button>
          </>
        );


      case "MATCHING":
        return (
          <div>
            {/* 🟦 Interface visuelle de l'appariement */}
            <MatchingQuestion
              pairs={answers.map(a => ({
                id: a.id,
                leftText: a.leftText,
                rightText: a.rightText,
              }))}
            />


            {/* 🟨 Inputs pour ajouter une nouvelle paire */}
            <div style={{ display: 'flex', marginTop: 20, gap: 10 }}>
              <Input
                placeholder="Texte gauche"
                value={leftText}
                onChange={(e) => setLeftText(e.target.value)}
              />
              <Input
                placeholder="Texte droit"
                value={rightText}
                onChange={(e) => setRightText(e.target.value)}
              />
              <Button type="primary" icon={<PlusOutlined />} onClick={handleAddMatchingPair}>
                Ajouter la pairee
              </Button>
            </div>
          </div>
        );


      default:
        return <div>Aucune réponse disponible pour ce type.</div>;
    }
  };



  // 🔵 Nouvelle fonction pour rendre tout le contenu principal sans modal
  const renderControleConnaissanceManagement = () => (
    <div style={{ display: "flex", gap: "20px" }}>
      <Card title="Liste des controles" style={{ width: "40%", backgroundColor: "#f8f9fa" }}>
        {loading ? <Spin indicator={<LoadingOutlined />} /> : null}
        <div style={{ marginBottom: "20px" }}>
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={() => setIsQuizModalVisible(true)}
          >
            Ajouter un controle
          </Button>

          <Modal
            title=""
            open={isQuizModalVisible}
            onCancel={() => setIsQuizModalVisible(false)}
            onOk={async () => {
              try {
                const values = await form.validateFields();
                console.log("✅ Valeurs du formulaire :", {
                  ...values,
                  title: newQuizTitle,
                  attemptOnce
                });

                // Ton ancienne logique ici si nécessaire
                await handleAddQuiz(); // ou passe les valeurs directement
              } catch (error) {
                console.log("❌ Erreur validation formulaire :", error);
              }
            }}
            okText="Ajouter"
            cancelText="Annuler"
          >
            <Form form={form} layout="vertical">
              <Row gutter={24}>
                <Col span={24}>
                  <Input
                    placeholder="Titre du quiz"
                    value={newQuizTitle}
                    onChange={(e) => setNewQuizTitle(e.target.value)}
                  />
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="elementType"
                    label="Type d’élément"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <Select
                      onChange={(value) => {
                        setSelectedElementType(value);
                        fetchElementsByType(value);
                      }}
                    >
                      <Select.Option value="SUBJECT">Sujet</Select.Option>
                      <Select.Option value="TRAINING">Entraînement</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="referenceElementId"
                    label="Insérer par rapport à l’élément"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <Select disabled={selectedElementType !== "SUBJECT"}>
                      {courseElements.map((group) => (
                        <Select.Option key={group.referenceId} value={group.referenceId}>
                          {group.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="positioning"
                    label="Positionner"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <Select>
                      <Select.Option value="BEFORE">Avant</Select.Option>
                      <Select.Option value="AFTER">Après</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>

            <Checkbox
              checked={attemptOnce}
              onChange={(e) => setAttemptOnce(e.target.checked)}
              style={{ marginTop: 10 }}
            >
              Tentative unique ?
            </Checkbox>
          </Modal>


        </div>

        <List
          dataSource={quizzes}
          renderItem={(quiz) => (
            <List.Item
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              {editQuizId === quiz.id ? (
                <div
                  style={{
                    border: "2px solid #91d5ff",
                    borderRadius: "12px",
                    backgroundColor: "#e6f7ff",
                    padding: "24px",
                    marginTop: 16,
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <h2 style={{ color: "#1890ff", marginBottom: 24, display: "flex", alignItems: "center", gap: 8 }}>
                    <EditOutlined />
                    Modifier le Quiz
                  </h2>

                  <Row gutter={32}>
                    <Col span={12} style={{ borderRight: "1px solid #d9d9d9", paddingRight: 16 }}>
                      <Form layout="vertical">
                        <Form.Item label="Titre du Quiz">
                          <Input
                            value={editQuizTitle}
                            onChange={(e) => setEditQuizTitle(e.target.value)}
                            placeholder="Titre du Quiz"
                          />
                        </Form.Item>

                        <Form.Item label="Tentative unique">
                          <Checkbox
                            checked={attemptOnce}
                            onChange={(e) => setAttemptOnce(e.target.checked)}
                          >
                            Le quiz ne peut être tenté qu’une seule fois
                          </Checkbox>
                        </Form.Item>

                        <Form.Item label="Progression (en %)">
                          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <Button icon={<MinusOutlined />} onClick={() => decreaseProgress(quiz.id)} />
                            <Progress type="circle" percent={quiz.progressPercentage || 0} width={60} />
                            <Button icon={<PlusOutlined />} onClick={() => increaseProgress(quiz.id)} />
                          </div>
                          <Input
                            type="number"
                            value={quiz.progressPercentage || 0}
                            // onChange={(e) => handleProgressChange(quiz.id, e.target.value)}
                                onChange={(e) => setProgressPercentage(Number(e.target.value))}

                            onBlur={() => handleProgressBlur(quiz.id)}
                            min={0}
                            max={100}
                            style={{ marginTop: 10 }}
                            suffix="%"
                          />
                        </Form.Item>
                      </Form>
                    </Col>

                    <Col span={12} style={{ paddingLeft: 16 }}>
                      <Form layout="vertical">
                        <Form.Item label="Type d’élément">
                          <Select
                            value={editElementType}
                            onChange={(val) => {
                              setEditElementType(val);
                              setEditReferenceElementId(null);
                              if (val === "SUBJECT") fetchElementsByType(val);
                            }}
                          >
                            <Select.Option value="SUBJECT">Sujet</Select.Option>
                            <Select.Option value="TRAINING">Entraînement</Select.Option>
                          </Select>
                        </Form.Item>

                        <Form.Item label="Insérer par rapport à l’élément">
                          <Select
                            value={editReferenceElementId}
                            onChange={(val) => setEditReferenceElementId(val)}
                            disabled={editElementType !== "SUBJECT"}
                            placeholder="Choisir un élément"
                          >
                            {courseElements.map(el => (
                              <Select.Option key={el.referenceId} value={el.referenceId}>
                                {el.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.Item label="Positionner">
                          <Select
                            value={editPositioning}
                            onChange={(val) => setEditPositioning(val)}
                            placeholder="Avant ou Après"
                          >
                            <Select.Option value="BEFORE">Avant</Select.Option>
                            <Select.Option value="AFTER">Après</Select.Option>
                          </Select>
                        </Form.Item>
                      </Form>
                    </Col>
                  </Row>

                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24, gap: 12 }}>
                    <Button type="primary" icon={<SaveOutlined />} onClick={() => handleSaveQuiz(quiz.id)}>
                      Enregistrer
                    </Button>
                    <Button danger onClick={() => setEditQuizId(null)}>
                      Annuler
                    </Button>
                  </div>
                </div>

              ) : (
                <>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span>{quiz.title} ({quiz.progressPercentage}%)</span>
                    {quiz.attemptOnce && (
                      <Tag color="red">Tentative unique</Tag>
                    )}
                  </div>

                  <div>
                    <Button type="link" onClick={() => handleSelectQuiz(quiz)}>Sélectionner</Button>
                    <Button type="link" icon={<EditOutlined />} onClick={() => handleEditQuizClick(quiz)} />
                    <Button type="link" danger icon={<DeleteOutlined />} onClick={() => handleDeleteQuiz(quiz.id)} />
                  </div>
                </>
              )}
            </List.Item>
          )}
        />

      </Card>

      {selectedQuiz && (
        <div style={{ display: "flex", flexDirection: "column", width: "65%", gap: "20px" }}>
          {/* Questions / Explications / Réponses */}
          {/* <Card title={`Questions du Quiz : ${selectedQuiz.title}`} style={{ backgroundColor: "#e3f2fd" }}> */}
          {/* <Card title={`Questions du Quiz : ${selectedQuiz.title} (Total Score: ${totalScore})`} style={{ backgroundColor: "#e3f2fd" }}> */}
          <Card
            title={
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>Questions du Quiz : {selectedQuiz.title}</span>
                <span style={{ fontWeight: "bold", color: "#52c41a" }}>
                  Total Score : {totalScore}
                </span>
              </div>
            }
            style={{ backgroundColor: "#e3f2fd" }}
          >

            {/* Zone d'ajout de question */}
            <Input
              placeholder="Nouvelle question"
              value={newQuestionText}
              onChange={(e) => setNewQuestionText(e.target.value)}
              style={{ marginBottom: 10 }}
            />

            <Select
              style={{ width: "100%", marginBottom: 10 }}
              value={newQuestionType}
              onChange={(value) => setNewQuestionType(value)}
            >
              <Select.Option value="QCU">Choix Unique</Select.Option>
              <Select.Option value="QCM">Choix Multiple</Select.Option>
              <Select.Option value="DRAG_DROP">Drag & Drop</Select.Option>
              <Select.Option value="VRAI_FAUX">Vrai / Faux</Select.Option>
              <Select.Option value="MATCHING">Appariement (Matching)</Select.Option>

            </Select>

            <Button type="primary" icon={<PlusOutlined />} onClick={handleAddQuestion}>
              Ajouter une Question
            </Button>


            <List
              dataSource={questions}
              renderItem={(question) => (
                <List.Item
                  style={{
                    backgroundColor: selectedQuestion?.id === question.id ? "#d3f9d8" : "#e3f2fd",
                    marginTop: 10,
                    padding: 10,
                    borderRadius: 8,
                  }}
                  onClick={() => handleSelectQuestion(question)}
                >
                  {editQuestionId === question.id ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
                      <Input
                        value={editQuestionText}
                        onChange={(e) => setEditQuestionText(e.target.value)}
                        placeholder="Texte de la question"
                      />
                      <Select
                        value={editQuestionType}
                        onChange={(value) => setEditQuestionType(value)}
                        placeholder="Type de question"
                      >
                        <Select.Option value="QCU">Choix Unique</Select.Option>
                        <Select.Option value="QCM">Choix Multiple</Select.Option>
                        <Select.Option value="DRAG_DROP">Drag & Drop</Select.Option>
                        <Select.Option value="VRAI_FAUX">Vrai / Faux</Select.Option>
                        <Select.Option value="MATCHING">Appariement</Select.Option>
                      </Select>
                      <Input
                        type="number"
                        value={editQuestionScore}
                        onChange={(e) => setEditQuestionScore(e.target.value)}
                        placeholder="Score"
                      />

                      <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                        <Button type="primary" onClick={handleEditQuestion} loading={loadingSaveQuestion}>
                          Enregistrer
                        </Button>
                        <Button danger onClick={() => setEditQuestionId(null)}>
                          Annuler
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                      <div>
                        {question.text} ({question.questionType}) - Score: {question.score ?? 0}
                      </div>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <Button
                          icon={<EditOutlined />}
                          onClick={(e) => {
                            e.stopPropagation();
                            setEditQuestionId(question.id);
                            setEditQuestionText(question.text);
                            setEditQuestionScore(question.score ?? 0);
                            setEditQuestionType(question.questionType);
                          }}
                        />
                        <Button
                          icon={<DeleteOutlined />}
                          danger
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteQuestion(question.id);
                          }}
                        />
                      </div>
                    </div>
                  )}
                </List.Item>
              )}
            />

          </Card>

          {selectedQuestion && (
            <>
              {/* Explication */}
              <Card title={`Explication pour : ${selectedQuestion.text}`} style={{ backgroundColor: "#e8f5e9" }}>
                <Editor
                  apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                  value={newQuestionExplanation}
                  onEditorChange={(content) => setNewQuestionExplanation(content)}
                  init={{
                    height: 300,
                    menubar: true,
                    plugins: "link image media table code help wordcount",
                    toolbar: "undo redo | bold italic underline | link image | alignleft aligncenter alignright | code",
                  }}
                />
                <Button type="primary" onClick={handleUpdateExplanation} style={{ marginTop: 10 }}>
                  Enregistrer Explication
                </Button>
              </Card>

              {/* Réponses */}
              <Card title={`Réponses pour : ${selectedQuestion.text}`} style={{ backgroundColor: "#fff3cd" }}>
                {/* Afficher les réponses actuelles */}
                {renderAnswerInput()}

          
                {selectedQuestion?.questionType !== "VRAI_FAUX" && selectedQuestion?.questionType !== "MATCHING" && (
                  <>
                    <Input
                      placeholder="Nouvelle réponse"
                      value={newAnswerText}
                      onChange={(e) => setNewAnswerText(e.target.value)}
                      style={{ marginTop: 10 }}
                    />
                    <Button
                      type="primary"
                      onClick={handleAddAnswer}
                      icon={<PlusOutlined />}
                      style={{ marginTop: 10 }}
                    >
                      Ajouter une réponse
                    </Button>
                  </>
                )}



              </Card>

            </>
          )}
        </div>
      )}
    </div>
  );
  const [form] = Form.useForm();

  return (

    <>

      <>
        {/* 🔵 Version intégrée dans la page */}
        {showInPage && renderControleConnaissanceManagement()}

        {/* 🔵 Ancienne version avec bouton + modal */}
        {!showInPage && (
          <>
            <Button onClick={() => setIsModalVisible(true)}>Gérer les Quizzes</Button>
            <Modal
              title="Gestion des Quizzes"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={<Button onClick={() => setIsModalVisible(false)}>Fermer</Button>}
              width="95%"
            >
              {renderControleConnaissanceManagement()}
            </Modal>
          </>
        )}
      </>
    </>

  );
};

export default ControleConnaissanceManager;
